export default __webpack_public_path__ + "static/media/heba.02f48a7a.jpg";